
import { defineComponent } from 'vue';
import { useStore } from '@/store';
import { ActionTypes } from '@/store/actions';

type Props = {
    options: string;
};

export default defineComponent({
    name: 'App',
    props: {
        options: { type: String, required: true }
    },
    setup (props: Props) {
        const store = useStore();
        store.dispatch(ActionTypes.SetInitialOptions, props.options);
    }
});
